import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DialogService } from '@salesrun/ngx-dialog';
import { DEFAULT_DEBOUNCE_TIME } from '@shared/constants';
import { EMPTY, Subject } from 'rxjs';
import { catchError, debounceTime, switchMap, takeUntil, tap } from 'rxjs';
import { LoginService } from '../login.service';



@Component({
    selector: 'sr-login-password-page',
    templateUrl: './password-page.view.html',
    styleUrls: ['./password-page.style.scss'],
    standalone: false
})
export class PasswordPageComponent implements OnInit, OnDestroy {

    private _destroy$ = new Subject<boolean>();
    @HostBinding('dfsdf') passwordForm: UntypedFormGroup;
    loading = false;
    errorMsg: string;
    isError = false;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private _login: LoginService,
        private _dialog: DialogService,
        private _router: Router,
    ) {
        this.passwordForm = this.formBuilder.group({
            userName: [
                undefined,
                Validators.compose([
                    Validators.required,
                    this._userNameValidators,
                ])],
        });
    }

    ngOnInit(): void {

        this.passwordForm.valueChanges
            .pipe(
                debounceTime(DEFAULT_DEBOUNCE_TIME),
                takeUntil(this._destroy$),
            )
            .subscribe((() => {
                this.isError = false;
            }));
    }
    request(): void {
        this.isError = false;
        this.loading = true;
        const userName = this.passwordForm.controls.userName.value;
        if (!userName) {
            return;
        }
        this._login.requestResetPassword(this.passwordForm.controls.userName.value)
            .pipe(
                catchError(err => {
                    this.errorMsg = err.error;
                    this.isError = true;
                    this.passwordForm.controls.userName.updateValueAndValidity();
                    this.loading = false;
                    return EMPTY;
                }),
                tap(() => { this.loading = false; }),
                switchMap(() => this._dialog.ok('A Password link has been sent to your email. ' +
                    'Please check your email and follow the Password Reset instructions.',
                    'Request Password'),
                ),
            )
            // eslint-disable-next-line
            .subscribe(response => {
                void this._router.navigate(['login']);
            });
    }


    private _userNameValidators = (control: AbstractControl): unknown => {
        if (this.passwordForm && control.value != undefined && this.isError) {
            return { customError: true };
        }
        return null;
    };

    ngOnDestroy(): void {
        this._destroy$.next(true);
        this._destroy$.complete();
    }
}